import { css } from 'styled-components';

const customReset = css`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  a {
    color: inherit;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  }

  button,
  input {
    appearance: none;
    background: none;
    border-radius: 0;
    border: 0;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    margin: 0;
    overflow: visible;
    padding: 0;
    text-align: left;
    
    &:[type="button"],
    &:[type="submit"] {
      cursor: pointer;
    }

    &[data-focus-method='mouse'],
    &[data-focus-method='touch'] {
      outline: none;
    }
  }

  hr {
    margin: 0;
  }

  [tabindex="-1"]:focus {
    outline: none;
  }
`;

const baseReset = css`
  /* http://meyerweb.com/eric/tools/css/reset/
     v2.0 | 20110126
     License: none (public domain)
  */

  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  b,
  strong {
    font-weight: 500;
  }
  i,
  em {
    font-style: italic;
  }
`;

export const reset = css`
  ${baseReset}
  ${customReset}
`;
